export const GOOGLE = 'google';
export const GOOGLE_ID_TOKEN = 'google-id-token';
export const SLACK = 'slack';
export const SLACK_OIDC_CONNECT = 'slack-openid-connect';
export const WINDOWS = 'windows';
export const AUTH0 = 'auth0';
export const AUTH0_TEST = 'auth0-test';
export const APPLE = 'apple';
export const APPLE_IOS = 'apple-ios';
export const WORKOS = 'workos';
// used as placeholder for internal tools
export const INTERNAL = 'internal';

// special case for slack app install
export const GOOGLE_APP = 'add-google-app';
export const ALL = [
  GOOGLE,
  GOOGLE_ID_TOKEN,
  SLACK,
  SLACK_OIDC_CONNECT,
  WINDOWS,
  AUTH0,
  APPLE,
  WORKOS,
];
